// extracted by mini-css-extract-plugin
export var leftTab = "Benefits-module--left-tab--SK1Bk";
export var active = "Benefits-module--active--lAdvm";
export var rightTab = "Benefits-module--right-tab--UMBu2";
export var benefits = "Benefits-module--benefits--4spwa";